"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCpf = void 0;
function validateCpf(cpf) {
    if (cpf) {
        // se existir cpf
        cpf = cpf.replace(".", "");
        cpf = cpf.replace(".", "");
        cpf = cpf.replace("-", "");
        let numbers;
        let digits;
        let sum;
        let i;
        let result;
        let equalDigits = 1;
        if (cpf.length < 11) {
            // se tem 11 digitos
            return false;
        }
        else {
            for (i = 0; i < cpf.length - 1; i++) {
                // buscar digitos iguais
                if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                    equalDigits = 0;
                    break;
                }
            }
            if (!equalDigits) {
                numbers = cpf.substring(0, 9);
                digits = cpf.substring(9);
                sum = 0;
                for (i = 10; i > 1; i--) {
                    sum += parseInt(numbers.charAt(10 - i)) * i;
                }
                result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                if (result !== Number(digits.charAt(0))) {
                    // primeiro digito validador
                    return false;
                }
                else {
                    numbers = cpf.substring(0, 10);
                    sum = 0;
                    for (i = 11; i > 1; i--) {
                        sum += parseInt(numbers.charAt(11 - i)) * i;
                    }
                    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
                    if (result !== Number(digits.charAt(1))) {
                        // segundo digito  validador
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
            else {
                return false; // caso 1111111111 ou 2222222222
            }
        }
    }
    else {
        return false;
    }
}
exports.validateCpf = validateCpf;
//# sourceMappingURL=validateCpf.js.map